import {
  FunctionThread, Pool, spawn, Worker
} from "threads";
import { QueuedTask } from "threads/dist/master/pool-types";
import { hasNoElements } from "Utils/Array";
import { isNullOrWhiteSpace } from "Utils/String";
import { FilterWorker } from "./Worker";

const pool = Pool(() => spawn<FilterWorker>(new Worker(`./filterWorker.js`)), { size: 1 });

type FilterTask = QueuedTask<
FunctionThread<[items: unknown[], key: string, expression: string, usernames: string[], locale: string], string[]>,
Promise<string[]>
>;

let task: FilterTask = null;

function cancelTask(): void {
  if (task != null) {
    task.cancel();
    task = null;
  }
}

export async function filterByExpression<T>(
  items: T[],
  key: string,
  expression: string,
  usernames: string[]
): Promise<string[]> {
  cancelTask();

  if (hasNoElements(items)) {
    return Promise.resolve([]);
  }

  if (isNullOrWhiteSpace(expression)) {
    return Promise.resolve(items.map((i) => i[key]));
  }

  task = pool.queue((worker) => worker(items, key, expression, usernames));
  return task;
}
